import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { listPosts } from "../../actions/postActions";

const PostList = () => {
  const dispatch = useDispatch();
  const postList = useSelector((state) => state.postList);
  const { loading, error, posts } = postList;

  useEffect(() => {
    dispatch(listPosts());
  }, [dispatch]);

  return (
    <div>
      <h2>Posts</h2>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        <ul>
          {posts.map((post) => (
            <li key={post._id}>
              {post.title} - <a href={`/posts/${post._id}`}>View</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PostList;
